import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navigation from "@/components/Navigation";
import { scrollToId } from "@/components/SmoothScroll";
import KineticHero from "@/components/KineticHero";
import EditorialMarquee from "@/components/EditorialMarquee";
import Manifesto from "@/components/Manifesto";
import TexasWaterOpportunity from "@/components/TexasWaterOpportunity";
import WhatDesalinationIs from "@/components/WhatDesalinationIs";
import ProjectPipeline from "@/components/ProjectPipeline";
import PlatformLifecycle from "@/components/PlatformLifecycle";
import BrackishPlatform from "@/components/BrackishPlatform";
import Leadership from "@/components/Leadership";
import NewsPreview from "@/components/NewsPreview";
import ContactFooter from "@/components/ContactFooter";

export default function HomePage() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.slice(1);
      setTimeout(() => scrollToId(id), 400);
    }
  }, [location]);

  return (
    <div className="bg-bg-primary">
      <Navigation />
      <KineticHero />
      <EditorialMarquee />
      <Manifesto />
      <TexasWaterOpportunity />
      <WhatDesalinationIs />
      <ProjectPipeline />
      <PlatformLifecycle />
      <BrackishPlatform />
      <Leadership />
      <NewsPreview />
      <ContactFooter />
    </div>
  );
}
